import AxiosCall from './axiosCall';
import _ from 'lodash';
import { parseJwt } from './utilities';
import Axios from 'axios';
import { checkLocal, getAclBaseURL, getApiBaseURL, isStagingApp } from './helpers';
import { getDispatch, getState } from 'reducers';
import { updateAppState } from 'models/subscriptions/reducer';
import { loginRequest } from 'authConfig';
import { getCachePolicyInstance, getMsalInstance } from './msalInstance';
import { updateUserInfo } from 'models/user/reducer';
import jwt_decode from 'jwt-decode';
import { getUserGrpId } from 'models/user/selector';
import { getUserEmail } from 'models/user/selector';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import {
	deleteAPIData,
	deleteAPIDataV2,
	deleteAPIDataV3,
	getAPIData,
	getAPIDataV2,
	getAPIDataV3,
	getUserSettingsData,
	patchAPIDataV2,
	patchAPIDataV3,
	postAPIData,
	postAPIDataV2,
	postAPIDataV3,
	putAPIData,
	putAPIDataV2,
	putAPIDataV3,
} from './services/thetaretail/thetaretailService';
import {
	deleteAPIRaUploadData,
	getAPIRaUploadData,
	postAPIRaUploadData,
	putAPIRaUploadData,
} from './services/ra-upload/raUploadService';
require('axios-debug-log');

let currentToken = null;
export let tokenSources = [];
// Only allow email override in local dev — prevents privilege escalation in production
const overrideEmail = window.location.origin.match(/localhost/) ? localStorage.getItem('overrideEmail') : null;

const config = {
	apiBaseURL: getApiBaseURL(),
	aclBaseURL: getAclBaseURL(),
};

export async function cancelOngoingRequests() {
	await _.forEach(tokenSources, async (source) => {
		await source.cancel('CANCELLED');
	});
}

const getAppInfo = () => {
	let appId;
	if (window.location.origin.match(/dev-beta|localhost/)) {
		appId = 'theta-dev-staging';
	} else if (window.location.origin.match(/staging|localhost/)) {
		appId = 'theta-prod-staging';
	} else {
		appId = 'theta-prod';
	}
	return {
		appId,
	};
};

export function apiCallRouter(type, call, requestObj) {
	let obj = requestObj instanceof FormData ? requestObj : { ...requestObj, ...getAppInfo() };
	let source = Axios.CancelToken.source();
	tokenSources.push(source);
	switch (type) {
		case 'GET': {
			return call.get('', { params: obj, cancelToken: source.token });
		}
		case 'POST': {
			return call.post('', obj, { cancelToken: source.token });
		}
		case 'PATCH': {
			return call.patch('', obj, { cancelToken: source.token });
		}
		case 'PUT': {
			return call.put('', obj, { cancelToken: source.token });
		}
		case 'DELETE': {
			return call.delete('', { data: obj, cancelToken: source.token });
		}
		default: {
			return call.get('');
		}
	}
}

async function getAllTenent(email, token) {
	const dispatch = getDispatch();
	let axiosData = {};
	try {
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/tenant/list`;
		} else {
			baseURL = `${config.apiBaseURL}/api/tenant/list`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
	}
	return apiCallRouter('POST', axiosData.INSTANCE, { email }).catch((error) => {
		if (error?.response?.status === 401 || error?.response?.status === 500 || error?.response?.status === 400) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject(error.response || error);
		}
		return Promise.reject(error.response || error);
	});
}

export async function selectTenent(email, partnerId, token) {
	const dispatch = getDispatch();
	let axiosData = {};
	try {
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/tenant/selectcompany`;
		} else {
			baseURL = `${config.apiBaseURL}/api/tenant/selectcompany`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return;
	}
	return apiCallRouter('POST', axiosData.INSTANCE, { email, partnerId }).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

export async function getUserTenent(email, token) {
	const dispatch = getDispatch();
	let axiosData = {};
	try {
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/tenant/Selectedcompany`;
		} else {
			baseURL = `${config.apiBaseURL}/api/tenant/Selectedcompany`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return;
	}
	return apiCallRouter('POST', axiosData.INSTANCE, { email }).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

export const getToken = async () => {
	const msalInstance = getMsalInstance();
	const email = getUserEmail(getState());
	const grpId = getUserGrpId(getState());
	const account = email
		? msalInstance.getAccountByUsername(email)
		: msalInstance.getAllAccounts()[0] || null;
	const dispatch = getDispatch();

	let userData;

	try {
		// Check if the current token is expired or about to expire (less than 5 minutes)
		let expiration = currentToken ? (jwt_decode(currentToken)?.exp ?? 0) * 1000 - Date.now() : 0;

		// If the token is expired or doesn't exist, attempt to acquire a new one
		if (expiration < 5 * 60 * 1000 || !currentToken) {
			let data = await msalInstance.acquireTokenSilent({
				scopes: loginRequest.scopes,
				loginHint: email || account?.username,
				cacheLookupPolicy: getCachePolicyInstance().AccessTokenAndRefreshToken,
				account: account,
			});

			// Set the current token
			currentToken = 'Bearer ' + data?.accessToken;
			const result = await fetchAndUpdateUserInfo(data);
			if (result && result?.hasOwnProperty('status') && result?.status === 500) {
				console.log(result);
				return { token: currentToken, userData, error: result };
			} else {
				return { token: currentToken, userData: result };
			}
		} else {
			// Token is still valid; use existing token for user data
			if (email && grpId) {
				userData = {
					userEmail: email,
					grpId,
				};
			}
			return { token: currentToken, userData };
		}
	} catch (e) {
		dispatch(updateAppState({ isLoggedOutUser: true }));
		if (e instanceof InteractionRequiredAuthError) {
			try {
				// If silent token acquisition fails, prompt the user for re-authentication
				let data = await msalInstance.acquireTokenRedirect({
					scopes: loginRequest.scopes,
					loginHint: email,
					account: account,
				});

				currentToken = 'Bearer ' + data?.accessToken;
				userData = await fetchAndUpdateUserInfo(data);
				return { token: currentToken, userData };
			} catch (redirectError) {
				console.error('Error during redirect token acquisition:', redirectError);
				return e;
			}
		} else {
			if (currentToken) {
				logOut();
			}
			console.error('Error acquiring token:', e.errorCode);
			if (e.errorCode === 'invalid_grant') {
				logOut();
			}
			return e;
		}
	}
};

export function getUserData() {
	return AxiosCall.post('/.auth/me', {
		headers: {
			'access-control-allow-origin': window.location.origin,
		},
	});
}

export function getUserGraphData(auth) {
	let inst = Axios.create({
		baseURL: 'https://graph.microsoft.com/v1.0',
		timeout: 600000,
	});
	return inst.get('/me');
}

async function fetchAndUpdateUserInfo(data) {
	try {
		const dispatch = getDispatch();

		let idToken = data.idToken;
		let accessToken = data.accessToken;
		let grpId = getUserGrpId(getState());
		let allTenentList = [];
		if (!idToken) {
			throw new Error('token expired');
		}
		let auth_obj = parseJwt(accessToken);
		const userEmail = overrideEmail || auth_obj?.email || auth_obj?.unique_name;
		if (!grpId) {
			const response = await getUserTenent(userEmail, data.accessToken);
			const userDetails = response?.data?.data;
			if (userDetails) {
				grpId = userDetails.PartnerID;
			} else {
				const response = await getAllTenent(userEmail, data.accessToken);
				allTenentList = response?.data?.data?.selectedparentPartners ?? [];
				if (allTenentList && allTenentList.length > 0) {
					const selectedTenent = await selectTenent(userEmail, allTenentList[0].PartnerID, data.accessToken);
					grpId = selectedTenent?.data?.data?.PartnerId;
				}
			}
		}
		sessionStorage.setItem('grpid', grpId);
		sessionStorage.setItem('userEmail', userEmail);
		sessionStorage.setItem('userName', auth_obj.name);
		let userInfo = { grpId, userEmail, accessToken };
		let userJson = {
			email: userEmail,
			groupId: grpId,
		};
		let base64EncodedUserJson = window.btoa(JSON.stringify(userJson));

		dispatch(
			updateUserInfo({
				userName: overrideEmail || auth_obj.name,
				userEmail,
				grpId,
				allTenentList,
			})
		);
		return userInfo;
	} catch (error) {
		return error;
	}
}

export function getUserBarData() {
	return AxiosCall.post('/.auth/me', null, {
		headers: {
			'access-control-allow-origin': window.location.origin,
		},
	}).catch((error) => ({ ...error, isError: true }));
}

export function getUserRefresh() {
	return AxiosCall.get('/.auth/refresh');
}

export function logOut(refresh) {
	localStorage.clear();
	sessionStorage.clear();
	document.cookie.split(';').forEach(function (c) {
		document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	});
	if (refresh) {
		window.location.reload();
	}
	window.location.href = '/.auth/logout?post_logout_redirect_uri=/index.html';
}

export async function silentLogin() {
	if (!!window.chrome) {
		let domainHint = window.location.host.split('.')[0]; //Domain of your organization users (e.g. me@contoso.com)

		//Remove existing iframe (if exists), to minimize history/back button entries
		let existingFrame = document.getElementById('authIFrame');
		if (existingFrame) {
			existingFrame.remove();
		}

		//Inject iFrame that will call endpoint to refresh token/cookie

		let iframe = document.createElement('iframe');
		iframe.id = 'authIFrame';
		iframe.style = 'width: 0; height: 0; border: 0; border: none; position: absolute; visibility: hidden;';
		iframe.src = `/.auth/login/aad?prompt=none`;
		document.body.appendChild(iframe);
		await new Promise((resolve, reject) => setTimeout(resolve, 2000));
	} else {
	}
}

export function relogin() {
	window.location.replace('/.auth/login/aad?post_login_redirect_url=/?restoreData=true');
}

export {
	getAPIData,
	getAPIDataV3,
	getAPIDataV2,
	postAPIData,
	postAPIDataV2,
	postAPIDataV3,
	putAPIData,
	putAPIDataV2,
	putAPIDataV3,
	patchAPIDataV2,
	patchAPIDataV3,
	deleteAPIData,
	deleteAPIDataV2,
	deleteAPIDataV3,
	getAPIRaUploadData,
	postAPIRaUploadData,
	putAPIRaUploadData,
	deleteAPIRaUploadData,
	getUserSettingsData,
	checkLocal,
};
